// State name to abbreviation mapping utility
const STATE_ABBREVIATIONS = {
  'ALABAMA': 'AL',
  'ALASKA': 'AK',
  'ARIZONA': 'AZ',
  'ARKANSAS': 'AR',
  'CALIFORNIA': 'CA',
  'COLORADO': 'CO',
  'CONNECTICUT': 'CT',
  'DELAWARE': 'DE',
  'FLORIDA': 'FL',
  'GEORGIA': 'GA',
  'HAWAII': 'HI',
  'IDAHO': 'ID',
  'ILLINOIS': 'IL',
  'INDIANA': 'IN',
  'IOWA': 'IA',
  'KANSAS': 'KS',
  'KENTUCKY': 'KY',
  'LOUISIANA': 'LA',
  'MAINE': 'ME',
  'MARYLAND': 'MD',
  'MASSACHUSETTS': 'MA',
  'MICHIGAN': 'MI',
  'MINNESOTA': 'MN',
  'MISSISSIPPI': 'MS',
  'MISSOURI': 'MO',
  'MONTANA': 'MT',
  'NEBRASKA': 'NE',
  'NEVADA': 'NV',
  'NEW HAMPSHIRE': 'NH',
  'NEW JERSEY': 'NJ',
  'NEW MEXICO': 'NM',
  'NEW YORK': 'NY',
  'NORTH CAROLINA': 'NC',
  'NORTH DAKOTA': 'ND',
  'OHIO': 'OH',
  'OKLAHOMA': 'OK',
  'OREGON': 'OR',
  'PENNSYLVANIA': 'PA',
  'RHODE ISLAND': 'RI',
  'SOUTH CAROLINA': 'SC',
  'SOUTH DAKOTA': 'SD',
  'TENNESSEE': 'TN',
  'TEXAS': 'TX',
  'UTAH': 'UT',
  'VERMONT': 'VT',
  'VIRGINIA': 'VA',
  'WASHINGTON': 'WA',
  'WEST VIRGINIA': 'WV',
  'WISCONSIN': 'WI',
  'WYOMING': 'WY',
  'DISTRICT OF COLUMBIA': 'DC',
  'WASHINGTON DC': 'DC'
};

/**
 * Get state abbreviation from full state name
 * @param {string} stateName - Full state name (case insensitive)
 * @returns {string} - Two-letter state abbreviation or original name if not found
 */
export const getStateAbbreviation = (stateName) => {
  if (!stateName || typeof stateName !== 'string') {
    return stateName || '';
  }
  
  const normalizedName = stateName.trim().toUpperCase();
  return STATE_ABBREVIATIONS[normalizedName] || stateName;
};

/**
 * Get full state name from abbreviation
 * @param {string} abbreviation - Two-letter state abbreviation
 * @returns {string} - Full state name or original abbreviation if not found
 */
export const getStateName = (abbreviation) => {
  if (!abbreviation || typeof abbreviation !== 'string') {
    return abbreviation || '';
  }
  
  const normalizedAbbr = abbreviation.trim().toUpperCase();
  const entry = Object.entries(STATE_ABBREVIATIONS).find(([_, abbr]) => abbr === normalizedAbbr);
  return entry ? entry[0] : abbreviation;
};

const stateUtilities = { getStateAbbreviation, getStateName };

export default stateUtilities;